exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.autocomplete[data-v-029fb607] {\n    position: relative;\n}\n.autocomplete-results[data-v-029fb607] {\n    background: #eeeeee;\n    padding: 0;\n    margin: 0;\n    border: 1px solid #cccccc;\n    border-radius: 3px;\n    height: 300px;\n    overflow: auto;\n    width: 100%;\n    z-index: 3;\n}\n.autocomplete-result[data-v-029fb607] {\n    list-style: none;\n    text-align: left;\n    padding: 4px 2px;\n    cursor: pointer;\n}\n.autocomplete-result[data-v-029fb607]:hover {\n    background-color: #dddddd;\n}\n.autocomplete-result.is-active[data-v-029fb607] {\n    background-color: #35495E;\n    color: white;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-029fb607","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/autocomplete.vue
// module id = 794
// module chunks = 0